export default __webpack_public_path__ + "static/media/map_marker.145033b7.svg";